import { Injectable } from '@angular/core';
import { PKCEAuthorizationCodeRequestBodyFactoryService } from './p-k-c-e-authorization-code-request-body-factory.service';
import { PKCEAuthorizationCodeRequestHeadersFactoryService } from './p-k-c-e-authorization-code-request-headers-factory.service';
import { AuthorizationCodeRequestConfigurationService } from '../../../configuration/auth/authorization-code-request-configuration/authorization-code-request-configuration.service';
import { AuthorityConfigurationService } from 'src/app/shared/configuration/auth/authority/authority-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class PKCEAuthorizationCodeRequestService {

  get grant_type() {
    return "authorization_code";
  }

  get redirect_uri() {
    return this.authorizationCodeRequestConfiguration.redirect_uri;
  }

  get path() {
    return this.authorizationCodeRequestConfiguration.path;
  }

  get addSuperBatmanHeader() {
    return this.authorityConfiguration.addSuperBatmanHeader;
  }

  get authorizationCodeRequestConfiguration() {
    return this.authorizationCodeRequestConfigurationService.configuration;
  }

  get authorityConfiguration() {
    return this.authorityConfigurationService.getDefaultConfiguration();
  }


  constructor(private authorizationCodeRequestBodyFactoryService: PKCEAuthorizationCodeRequestBodyFactoryService,
    private authorizationCodeRequestHeadersFactoryService: PKCEAuthorizationCodeRequestHeadersFactoryService,
    private authorizationCodeRequestConfigurationService: AuthorizationCodeRequestConfigurationService,
    private authorityConfigurationService: AuthorityConfigurationService) { }


    createBody(code, verifier) {
      return this.authorizationCodeRequestBodyFactoryService.createBody(code, verifier);
    }

    createHeaders() {
      return this.authorizationCodeRequestHeadersFactoryService.createHeaders();
    }

    createOptions() {
      const headers = this.createHeaders();
      return {
        headers: headers,
        addInstanceIdHeader: false,
        addFeatureTrackingHeaders: false,
        addSuperBatmanHeader: this.addSuperBatmanHeader
      };
    }
}
